/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

const paymentSandbox = !(process.env.VUE_APP_PAYMENT_PRODUCTION && process.env.VUE_APP_PAYMENT_PRODUCTION === 'true')

export default {
  customAttributes: {
    category: {
      lookCategory: 'bc_cat_type_name'
    }
  },
  API: {
    newsletter: {
      subscribeCustomer: `/newsletter/subscribeCustomer`
    },
    catalog: {
      categories: '/rest/{{storeViewCode}}/V1/categories/list?searchCriteria',
      listing: '/rest/{{storeViewCode}}/V1/products',
      product: 'rest/{{storeViewCode}}/V1/products/{{sku}}',
      sizeGuide: 'rest/{{storeViewCode}}/V1/sizeGuide',
      notifyMe: 'rest/V1/guest-product-alert/stocks'
    },
    google: {
      geolocate: 'https://www.googleapis.com/geolocation/v1/geolocate?key={{api_key}}',
      geocode: 'https://maps.googleapis.com/maps/api/geocode/json?latlng={{lat}},{{lng}}&result_type={{resultType}}&key={{api_key}}&language={{language}}&sensor=false',
      distances: 'https://maps.googleapis.com/maps/api/distancematrix/json?origins={{origins}}&destinations={{destinations}}&key={{api_key}}'
    },
    swatchPath: `${process.env.VUE_APP_MAGENTO}/media/attribute/swatch`,
    graphql: `graphql`,
    logs: {
      operationLog: 'rest/V1/api/logs/write-operation-log'
    },
    img: {
      entryPoint: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointWithoutPub: `${process.env.VUE_APP_MAGENTO}/media/catalog/product/`,
      entryPointIcon: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointXS: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointSM: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointMD: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointLD: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a  `,
      mediaCategoryPath: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/category`,
      placeholder: require('theme/assets/image/placeholder.png'),
      resizeUrl: `${process.env.VUE_APP_SERVER}/img`
    },
    users: {
      me: `rest/{{storeViewCode}}/V1/customers/me`,
      login: `/rest/{{storeViewCode}}/V1/Bcame/RestExtension/BoutiqueLogin`, // used in stage 11.05.21
      logout: `/rest/{{storeViewCode}}/V1/logout`,
      // login: `/rest/{{storeViewCode}}/V1/integration/admin/token`,
      create: `rest/{{storeViewCode}}/V1/customers`,
      resetPassword: `rest/{{storeViewCode}}/V1/customers/password`,
      resetPasswordFinalStep: `rest/{{storeViewCode}}/V1/customers/resetPassword`,
      emailAvailable: '/rest/{{storeViewCode}}/V1/customers/isEmailAvailable'
    },
    order: {
      list: '/orders',
      update: '/rest/{{storeViewCode}}/V1/orders/updateOrder/{{orderId}}',
      single: '/rest/{{storeViewCode}}/V1/orders/{{orderId}}',
      shipments: '/shipments/{{orderId}}',
      reserve: `/api/orders/{{storeViewCode}}/reserve`,
      restoreQuote: `/api/orders/{{storeViewCode}}/restoreQuote`,
      reorder: `rest/{{storeViewCode}}/V1/api/cart/fillCartFromOrder?orderId={{orderId}}`
    },
    cart: {
      create: `/rest/{{storeViewCode}}/V1/carts/mine`,
      createGuest: `/rest/{{storeViewCode}}/V1/guest-carts`,
      items: `/rest/{{storeViewCode}}/V1/carts/mine/items`,
      itemsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items`,
      pull: `${process.env.VUE_APP_BASE_PATH}/api/carts/pull?token={{token}}&cartId={{cartId}}`,
      stock: `${process.env.VUE_APP_BASE_PATH}/api/stock/check?sku={{sku}}`,
      add: `/rest/{{storeViewCode}}/V1/carts/mine/items`,
      addGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items`,
      update: `/rest/{{storeViewCode}}/V1/carts/mine/items/{{itemId}}`,
      updateGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items/{{itemId}}`,
      addCoupon: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/coupons/{{couponId}}`,
      deleteCoupon: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/coupons/{{couponId}}`,
      delete: `/rest/{{storeViewCode}}/V1/carts/mine/items/{{itemId}}`,
      deleteGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items/{{itemId}}`,
      totals: `/rest/{{storeViewCode}}/V1/carts/mine/totals`,
      totalsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/totals`,
      giftCard: `/rest/{{storeViewCode}}/V1/carts/{{cartId}}/aw-giftcard/{{giftCardCode}}`,
      giftCardGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/aw-giftcard/{{giftCardCode}}`,
      switchGuestToLoggin: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}`,
      shippingInfo: `/rest/{{storeViewCode}}/V1/carts/mine/shipping-information`,
      shippingInfoGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/shipping-information`,
      shippingMethods: `/rest/{{storeViewCode}}/V1/carts/mine/shipping-methods`,
      shippingMethodsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/shipping-methods`,
      paymentMethods: `/rest/{{storeViewCode}}/V1/carts/mine/payment-methods`,
      paymentMethodsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/payment-methods`,
      placeOrder: `/rest/{{storeViewCode}}/V1/carts/mine/order`,
      placeOrderGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/order`,
      paymentInformation: `/rest/{{storeViewCode}}/V1/carts/mine/payment-information`,
      paymentInformationGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/payment-information`,
      // salesforce api
      cartDetails: `/rest/{{storeViewCode}}/V1/cartDetails`,
      cartCustomAttributes: '/rest/{{storeViewCode}}/V1/cartCustomAttributes',
      setGiftCard: 'rest/{{storeViewCode}}/V1/setGiftCard/{{cartId}}',
      setInvoice: 'rest/{{storeViewCode}}/V1/setInvoice/{{cartId}}',
      managePriceAdjustments: 'rest/{{storeViewCode}}/V1/managePriceAdjustments/{{cartId}}'
    },
    storeConfig: {
      loadByPath: '/rest/V1/storeConfig/loadByPath'
    },
    storeLocator: {
      allBoutiques: `/rest/V1/mwlocations`,
      allClickAndCollect: `/rest/V1/mwlocations/clickAndCollect`,
      boutiquesByLocation: `/rest/V1/mwlocations/searchByLocation`,
      singleBoutique: `/rest/V1/mwlocations/{{code}}`,
      updateStore: `/rest/V1/mwlocations/update/{{code}}`,
      updateWorkingHoursStore: `/rest/V1/mwlocations/updateWorkingHours/{{code}}`,
      productOnStore: `/extend_mw/location/updatefindastore` // IS A POST (product: productId)
    },
    countries: {
      allCountries: `/geolocator/system/table`
    },
    payments: {
      adyen: {
        imgPath: 'https://checkoutshopper-test.adyen.com/checkoutshopper/images/logos/{{type}}.svg',
        pos: {
          urls: {
            host: `${process.env.VUE_APP_MAGENTO}/adyen`,
            connection: '/connectedTerminals',
            sync: '/sync'
          },
          merchant: 'CoinSrlPOS',
          key: 'AQEphmfxKorNbx1Lw0m/n3Q5qf3Va4REA6BYVHQMsYyofFQ1m4/h8DdO5rgQwV1bDb7kfNy1WIxIIkxgBw==-V+QMrkC97DkngSloF4DjjCpvakfWunz5jB6NZpoRCQQ=-I&RW#6=m4zQ8D{3+'
        }
      },
      payByLink: {
        link: {
          urls: {
            host: `${process.env.VUE_APP_MAGENTO}/adyen/payByLink`
          },
          merchant: 'CoinSrlIT'
        }
      },
      satispay: {
        buttonjs: `${process.env.VUE_APP_SATISPAY}/web-button.min.js`,
        postPaymentId: `/rest/{{storeViewCode}}/V1/ext/satispay/payments`, // BUS da integrare
        getPaymentInfo: '/rest/{{storeViewCode}}/V1/ext/satispay/payments?satispayId={{satispayId}}'
      },
      unicredit: {
        getRedirect: `/rest/{{storeViewCode}}/V1/ext/pagonline/payment/{{orderId}}`, // BUS da integrare
        verify: '/rest/{{storeViewCode}}/V1/ext/pagonline/payment/verify' // BUS da integrare
      }
    },
    rma: {
      attachment: '/returns/attachment/upload'
    },
    common: {
      countries: `/rest/{{storeViewCode}}/V1/directory/countries`
    },
    cms: {
      menu: `${process.env.VUE_APP_BASE_PATH}/tmp/menu.json`,
      page: `/rest/{{storeViewCode}}/V1/snowdog/cmsPageIdentifier/{{indentifier}}/storeId/{{storeviewID}}`,
      pageId: `/rest/{{storeViewCode}}/V1/snowdog/cmsPage/{{pageID}}`,
      content: `/rest/{{storeViewCode}}/V1/snowdog/cmsBlockIdentifier/{{indentifier}}/storeId/{{storeviewID}}`,
      styleLib: '', // `${process.env.VUE_APP_CMS}/wp-includes/css/dist/block-library/style.min.css`,
      globalIDs: []
    },
    giftCard: {
      customerGiftCards: `/rest/{{storeViewCode}}/V1/awGiftcard/get-giftcards-by-customer`,
      checkStatus: `/rest/{{storeViewCode}}/V1/awGiftcard/{{giftcardCode}}`
    },
    customerService: `/contactusapi/attachment/upload`,
    search: {
      products: '/rest/{{storeViewCode}}/V1/products?searchCriteria',
      productEan: '/rest/{{storeViewCode}}/V1/products/ean', // is custom endpint (used by salsforce proxy)
      customers: '/rest/{{storeViewCode}}/V1/customers/search?searchCriteria',
      orders: '/rest/{{storeViewCode}}/V1/orders?searchCriteria'
    }
  },
  Theme: {
    name: 'VieWide',
    storeviewRegex: '[a-z0-9]{2,6}_[a-z0-9]{2,6}',
    priceIncludeTax: true,
    enableRoute: true,
    enablei18n: true,
    checkout: {
      disabledShippingMethods: ['rma_free_shipping']
    },
    listingFilters: {
      dropFilter: {
        columnsView: {
          selected: 4,
          options: [
            {
              icon: `<svg id="icon_2columns" xmlns="http://www.w3.org/2000/svg" width="45" height="36" viewBox="0 0 45 36">
                <rect width="45" height="36" class="bg" />
                <g class="lines">
                  <path d="M25.5,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" />
                  <path d="M25.5,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" transform="translate(-10)"/>
                </g>
              </svg>`,
              label: '2 columns',
              value: 2
            },
            {
              icon: `<svg id="icon_4columns" xmlns="http://www.w3.org/2000/svg" width="54" height="36" viewBox="0 0 54 36">
                <rect width="54" height="36" class="bg" />
                <g class="lines">
                  <path d="M20,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" />
                  <path d="M30,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" />
                  <path d="M40,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" />
                  <path d="M20,12a2,2,0,0,1,4,0V24a2,2,0,0,1-4,0Z" transform="translate(-10)" />
                </g>
              </svg>`,
              label: '4 columns',
              value: 4
            }
          ]
        }
      }
    },
    stores: [
      {
        label: 'Coin Online store',
        icon: '<svg class="o-icon fill-black"><use xlink:href="#shop-ecommerce"></use></svg>',
        isOnlineStore: true, // use this flag to understand if store is online, for example, if true show cart
        code: 'os_en'
      }
    ],
    onlineStore: {
      label: 'Coin Online store',
      icon: '<svg class="o-icon fill-black"><use xlink:href="#shop-ecommerce"></use></svg>',
      code: 'os_en'
    },
    orderSatuses: [
      {
        label: 'open', // use with i18n
        value: 'open'
      },
      {
        label: 'complete', // use with i18n
        value: 'completed'
      },
      {
        label: 'failed', // use with i18n
        value: 'failed'
      },
      {
        label: 'replaced', // use with i18n
        value: 'replaced'
      },
      {
        label: 'canceled', // use with i18n
        value: 'cancelled'
      },
      {
        label: 'created', // use with i18n
        value: 'created'
      },
      {
        label: 'new', // use with i18n
        value: 'new'
      }
    ],
    needHelpNumber: '‎+39 02 9475 8110',
    gridCol: 3,
    rootCategoryID: 2,
    maxSelectionQty: 30,
    blockTaxRuleID: 'vat_information',
    middlewares: {
      'redirect': require('theme/middlewares/redirect.middleware.js')
      // 'userAdminInit': require('theme/middlewares/userAdmin.middleware.js')
    },
    linkUtils: {
      privacyPolicy: 'https://coin.it/it-it/informativa-registrazione-utente/informativa-registrazione-utente.html'
    },
    sizeCountries: [
      { value: 'IT' },
      { value: 'EU' },
      { value: 'UK' },
      { value: 'US' },
      { value: 'AU' },
      { value: 'JP' }
    ],
    defaultCountry: {
      'IT': 'IT',
      'GB': 'UK',
      'UK': 'UK',
      'AU': 'AU',
      'US': 'US',
      'EU': 'EU',
      'HR': 'EU',
      'JP': 'JP',
      'HK': 'JP',
      'CA': 'US'
    },
    widthMobile: 1025,
    defaultOpt: {
      imageCrop: {
        width: 500,
        height: 670,
        quality: 100
      }
    },
    listingOpt: {
      imageCrop: {
        width: 800,
        height: 800,
        quality: 100,
        c: true
      }
    },
    productOpt: {
      imageCrop: {
        crop: false,
        width: 900,
        quality: 100
      },
      teaserCrop: {
        crop: false,
        width: 600,
        height: 900,
        quality: 100
      }
    },
    swatchOpt: {
      imageOpt: {
        width: 100,
        quality: 100
      }
    },
    sort: 'position',
    sortOrientation: 'ASC',
    sortOrientationNegate: 'DESC',
    paginationSize: 32,
    default: {
      shippingMethod: 'ClickAndCollect',
      shippingMethods: [
        {
          method_code: 'ClickAndCollect',
          method_title: 'ClickAndCollect'
        }
      ],
      blogRoute: 'inspirations'
    },
    PaymentProduction: !paymentSandbox,
    forms: {
      genderValues: [
        {
          label: 'woman',
          value: 1 // magento value
        },
        {
          label: 'man',
          value: 2 // magento value
        }
      ],
      hidePayment: ['amazon_payment']
    },
    searchSuggestions: {
      categoryLimit: 4,
      productLimit: 5,
      ordersLimit: 16
    },
    attributesToload: [
      'description',
      'washing1',
      'washing2',
      'washing3',
      'washing4',
      'washing5',
      'washing6',
      'fitting_filter',
      'fitting',
      'technical_composition'
    ],
    wishlistAttributesToload: [],
    extGraph: {
      './product.js': 'graphProduct',
      './productConfigurable.js': 'productConfigurable',
      './listing.js': 'graphListing',
      './rmaNewPrepare.js': 'rmaNewPrepare'
    }
  }, // end Theme
  map: {
    zoom: 10
  },
  trackOrderCarrierLink: {
    UPS: 'https://www.ups.com/track?tracknum={{trackNumber}}&requester=ST/trackdetails',
    SDA: 'https://www.sda.it/wps/portal/Servizi_online/dettaglio-spedizione?locale=it&tracing.letteraVettura={{letteraVettura}}',
    TWS: 'https://www.mytws.it/tracking-status;ldv={{letteraVettura}}'
  }
}
